exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400i,600,600i,700,700i,800,800i);", ""]);

// module
exports.push([module.id, ".phone-component{display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center;flex-wrap:wrap}.phone-component strong{font-weight:bold;margin:0 10px}.phone-component .extension-part input[id*=\"_phone_extension\"]{max-width:125px;margin-bottom:0}.phone-component .input-wrapper{border:1px solid #767676}.phone-component .read-only-prefix{color:#767676;margin-left:0.5em}.phone-component .error>span{text-align:left;color:orange;font-weight:bold;display:block}.phone-component .error>input{border:1px solid orange;background:#ffedcc}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/sass/components/phone-number.scss
// module id = 650
// module chunks = 0